import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import PropTypes from 'prop-types';

import { useInspectors } from '@/hooks/useInspectors';

import InspectorsFilterComponent from './InspectorsFilterComponent';

const InspectorsFilterContainer = ({ handleSelect }) => {
  const intl = useIntl();
  const { useInspectorsList } = useInspectors();
  const { data: suggestions = [], isLoading: isBusy } = useInspectorsList();

  const handleChange = option => {
    const { value } = option;
    handleSelect(value);
  };


  return (
    <InspectorsFilterComponent
      suggestions={suggestions}
      isBusy={isBusy}
      searchPlaceholder={intl.formatMessage({
        id: 'PLACEHOLDER.SEARCH_INSPECTOR',
      })}
      handleChange={handleChange}
    />
  );
};

InspectorsFilterContainer.propTypes = {
  /**
   * Function to handle the selection
   */
  handleSelect: PropTypes.func.isRequired,
};

export default InspectorsFilterContainer;
